import * as React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';
import { QueryString, StringGuard, useEventListener } from '@grandvisionhq/utils';

const useResizeEventListener = (iframeId, iframeRef, setHeight, iframeHeight, initialHeight)=>{
    const iframeEventHandler = React.useCallback((e)=>{
        if (initialHeight || !Array.isArray(e.data)) {
            return;
        }
        const [eventName, eventValue, eventIframeId] = e.data;
        if (iframeId !== eventIframeId) {
            return;
        }
        if (eventName === 'setHeight' && iframeHeight !== eventValue) {
            setHeight(eventValue);
        } else if (eventName === 'scrollTop' && iframeRef.current) {
            iframeRef.current.scrollIntoView();
            window.scrollBy(0, -100);
        }
    }, [
        initialHeight,
        iframeHeight,
        iframeId,
        iframeRef
    ]);
    useEventListener('message', iframeEventHandler);
};
const IFrame = ({ source , title , height: initialHeight , scrolling , position ='center' ,  })=>{
    var ref;
    if (!source) {
        return null;
    }
    const [iframeHeight, setHeight] = React.useState(initialHeight);
    const iframeId = get(QueryString.parse((ref = source.split('?')) === null || ref === void 0 ? void 0 : ref[1]), 'iframeId', '');
    const iframeRef = React.useRef(null);
    useResizeEventListener(StringGuard.guard('iframeId', iframeId), iframeRef, setHeight, iframeHeight, initialHeight);
    return /*#__PURE__*/ React.createElement("div", {
        className: "site-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames('iframe', {
            [`iframe--${position}`]: !!position
        })
    }, /*#__PURE__*/ React.createElement("iframe", {
        ref: iframeRef,
        frameBorder: "0",
        src: source,
        height: iframeHeight,
        scrolling: `${scrolling ? 'yes' : 'no'}`,
        title: title
    })));
};
var IFrame$1 = IFrame;

export { IFrame$1 as default };
//# sourceMappingURL=Iframe.js.map
